import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { QuestionCircleFilled } from 'opencare-crown';

import {
  useWindowDimensions,
  DIMENSIONS,
} from '../../../../providers/WindowDimensionsProvider';
import { colors } from '../../../../common/styles/style-constants';
import {
  IconWrapper,
  StyledTooltip,
  OptionTitle,
  OptionDescription,
  CopyWrapper,
} from '../../styled-components';

import { CheckboxContainer } from './styled-components';

const Multiselect = ({
  id,
  name,
  title,
  onChange,
  describedBy,
  Icon,
  tooltip,
  description,
  className,
  initialSelected,
  alwaysSelected,
  columns,
  invisible,
}) => {
  const { layout } = useWindowDimensions();

  const [selected, setSelected] = useState(initialSelected);

  const hideIcon = layout === DIMENSIONS.MOBILE && tooltip;
  const tooltipBaseColor =
    layout === DIMENSIONS.MOBILE ? colors.sage : colors.gray5;
  const label =
    tooltip || description ? `${title}. ${tooltip || description}` : title;

  const handleChange = () => {
    // Don't allow unselecting if alwaysSelected is true
    if (alwaysSelected) return;

    const newValue = !selected;
    setSelected(newValue);

    onChange(title, id, newValue);
  };

  return (
    <CheckboxContainer
      id={`option-wrapper-${id}`}
      checked={selected}
      className={className}
      columns={columns}
      invisible={invisible}
    >
      <input
        type="checkbox"
        id={`option-${id}`}
        value={title}
        name={name}
        checked={selected}
        onChange={handleChange}
        data-testid={`option-${id}`}
        aria-describedby={describedBy}
        aria-label={label}
      />
      <label htmlFor={`option-${id}`}>
        {Icon && !hideIcon 
          && (
            <IconWrapper aria-hidden>
              <Icon color={colors.sage6} style={{ color: colors.sage6 }} />
            </IconWrapper>
          )
        }
        {tooltip 
          && (
            <StyledTooltip title={tooltip} aria-hidden>
              <QuestionCircleFilled
                aria-hidden
                style={{
                  color: selected ? colors.sage5 : tooltipBaseColor,
                }}
              />
            </StyledTooltip>
          )
        }
        <CopyWrapper aria-hidden>
          <OptionTitle>{title}</OptionTitle>
          {description && <OptionDescription>{description}</OptionDescription>}
        </CopyWrapper>
      </label>
    </CheckboxContainer>
  );
};

Multiselect.defaultProps = {
  Icon: null,
  tooltip: null,
  description: null,
  describedBy: null,
  initialSelected: false,
};

Multiselect.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  describedBy: PropTypes.string,
  Icon: PropTypes.elementType,
  tooltip: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  initialSelected: PropTypes.bool,
  alwaysSelected: PropTypes.bool,
  columns: PropTypes.number,
  invisible: PropTypes.bool,
};

export default Multiselect;
